import { buildMenuCategories } from '@root/components/v2/SideOverlayTabMenu/buildMenuCategories';
import { Bug, Info } from 'lucide-react';

// Vertical menus of the Kubernetes host vulnerability overlays. Each has a single tab, listed flat.
export const HOST_VULNERABILITY_MENU_CATEGORIES = buildMenuCategories(['Vulnerabilities'], undefined, key => ({
  key,
  label: 'Vulnerabilities',
  icon: Bug,
}));

export const HOST_CVE_MENU_CATEGORIES = buildMenuCategories(['Details'], undefined, key => ({
  key,
  label: 'Details',
  icon: Info,
}));
